// StatusBadge.jsx
import React from "react";

const StatusBadge = ({ status }) => {
  const statusConfig = {
    pending: { color: "bg-amber-100 text-amber-800 border border-amber-200", text: "Pending" },
    approved: { color: "bg-green-100 text-green-800 border border-green-200", text: "Approved" },
    rejected: { color: "bg-red-100 text-red-800 border border-red-200", text: "Rejected" },
    allowed: { color: "bg-blue-100 text-blue-800 border border-blue-200", text: "Allowed" },
    cancelled: { color: "bg-slate-100 text-slate-800 border border-slate-200", text: "Cancelled" }
  };

  const config = statusConfig[status] || statusConfig.pending;

  return (
    <span className={`px-3 py-1 rounded-full text-xs font-medium ${config.color}`}>
      {config.text}
    </span>
  );
};

export default StatusBadge;
